export default __webpack_public_path__ + "static/media/existingEmail.0c713821.svg";